"use client";

import { c as _c } from "react/compiler-runtime";
import { Track } from "@opensea/analytics";
import { classNames } from "@opensea/ui-kit";
import { Logout } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useDisconnect } from "@/hooks/use-disconnect";
import { AccountSwitcherItem, AccountSwitcherItemAvatar, AccountSwitcherItemContent, AccountSwitcherItemTitle } from "./AccountSwitcherItem";
export function AccountSwitcherLogoutItem(t0) {
  const $ = _c(19);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      source: "More Menu"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const disconnect = useDisconnect(t1);
  const t = useTranslations("AccountSwitcherLogoutItem");
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      event: "Logout Click",
      data: {
        source: "Logout More Menu"
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className) {
    t3 = classNames("text-error-1", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== disconnect) {
    t4 = async event => {
      await disconnect({
        event
      });
    };
    $[7] = disconnect;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AccountSwitcherItemAvatar className="text-inherit" icon={Logout} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("logoutTitle");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <AccountSwitcherItemContent><AccountSwitcherItemTitle className="text-inherit">{t6}</AccountSwitcherItemTitle></AccountSwitcherItemContent>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== rest || $[15] !== t3 || $[16] !== t4 || $[17] !== t7) {
    t8 = <Track click={t2}><AccountSwitcherItem className={t3} onClick={t4} {...rest}>{t5}{t7}</AccountSwitcherItem></Track>;
    $[14] = rest;
    $[15] = t3;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}